module.exports = __webpack_public_path__ + "img/SNLogoHorizontalBW.0e93e2f5.png";